// Modelo Dinamico para monitoreo.

//TIPO 0: Solo LABEL
//{valor:"", descripcion:"", tipo:0 ,label:"g. Exposiciones en trabajos anteriores (ver HCU):",label2:"Tipo Detalle"},

//TIPO 1: select con opciones
//{valor:"", descripcion:"", tipo:1 ,label:"a. Datos de filiación:" ,data:["SI","NO"]},

//TIPO 2: Select con opciones y un campo con descripcion
//{valor:"", descripcion:"", valor2:"", tipo:2 ,label:"Discoteca:",data:["SI","NO"],label2:"veces/mes"},

//TIPO 3: Campo para observaciones inputText
//{valor:"", descripcion:"", tipo:3 ,label:"Valor:"},

//TIPO 4: Campo para observaciones textArea
//{valor:"", descripcion:"", tipo:4 ,label:"Valor:"},

export default class MonitoreoRespiratorioRolandMorris {
    fecha={}
    lista=[
        {
            encabezado:"Datos de filiación",
            datos:[
                {valor:"", descripcion:"", tipo:21 ,label:"      C.I.: 1721930442", bold:false},
                {valor:"", descripcion:"", tipo:22 ,label:"      Edad: 32", bold:false},
                {valor:"", descripcion:"", tipo:23 ,label:"      Apellidos y nombres: LOPEZ CRISTIAN", bold:false},
                {valor:"", descripcion:"", tipo:24 ,label:"      Empresa: PRIVADOS", bold:false},
                {valor:"", descripcion:"", tipo:25 ,label:"      Puesto de trabajo: PRIVADO", bold:false},
            ]
        },
        {
            encabezado:"CUESTIONARIO DE ROLAND-MORRIS PARA EXPLORACIÓN DE PROBLEMAS DORSO-LUMBARES (RMQ)",
            datos:[

                {valor:"", descripcion:"", tipo:0 ,label:"Conteste con Si o NO" ,bold:true },

                {valor:"", descripcion:"", tipo:1 ,label:"1. Me quedo en casa la mayor parte del tiempo por mi dolor de espalda" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"2. Cambio de postura con frecuencia para intentar aliviar la espalda" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"3. Debido a mi espalda, camino más lentamente de lo normal" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"4. Debido a mi espalda, no puedo hacer ninguna de las tareas que habitualmente hago en casa" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"5. Por mi espalda, uso el pasamano para subir las gradas" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"6. A causa de mi espalda, me acuesto más a menudo para descansar" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"7. Debido a mi espalda, necesito agarrarme de algo para levantarme de una silla" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"8. Por culpa de mi espalda, pido a los demás que me hagan las cosas por mí\t" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"9. Me visto más lentamente que lo normal a causa de mi espalda" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"10. Sólo me quedo de pie durante cortos períodos de tiempo a causa de mi espalda" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"11. A causa de mi espalda, trato de evitar inclinarme o arrodillarme" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"12. Me cuesta levantarme de una silla por culpa de mi espalda" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"13. Me duele la espalda casi siempre" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"14. Me cuesta darme la vuelta en la cama por culpa de mi espalda" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"15. No tengo mucho apetito a causa de mi espalda" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"16. Tengo dificultad para ponerme los calcetines o medias por mi dolor de espalda" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"17. Solo puedo andar distancias cortas debido a mi dolor de espalda" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"18. Duermo peor debido a mi espalda" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"19. Por mi dolor de espalda, deben ayudarme a vestirme" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"20. Estoy casi todo el día sentado a causa de mi espalda" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"21. Evito hacer trabajos pesados en casa, por culpa de mi espalda" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"22. Por mi dolor de espalda, estoy más irritable y de peor humor de lo normal" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"23. A causa de mi espalda, subo las escaleras más lentamente de lo normal" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"24. Me quedo casi constantemente en la cama por mi espalda" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:3 ,label:"Puntaje" },
                {valor:"", descripcion:"", tipo:5 ,label:"Calcular", click:5 }

            ]
        },
    ]
}
var today = new Date();
var dd = today.getDate();
var mm = today.getMonth() + 1; //January is 0!

var yyyy = today.getFullYear();
if (dd < 10) {
    dd = '0' + dd;
}
if (mm < 10) {
    mm = '0' + mm;
}
var today = dd + '/' + mm + '/' + yyyy;





// WEBPACK FOOTER //
// ./src/model/MonitoreoMusculoEsqueleticoRolandMorris.js